import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

export function renderMessages(messages, setWarnData) {
    const alerts = messages.map(function (message, i) {
        
        const [show, setShow] = useState(true);
        window.setTimeout(()=>{            
            setWarnData(null);
            setShow(false);
        }, 5000);
        
        return (<Alert
            key={i}
            className="mb-2"
            variant="warning"
            show={show}
            onClose={() => setShow(false)}
            dismissible
        >
            {message}
        </Alert>)
    })

    return <div>{alerts}</div>;
};